<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <v-tabs class="mt-4 mb-10">
        <v-tab :to="{ name: 'Users' }">{{ $t("users") }}</v-tab>
        <v-tab :to="{ name: 'Roles' }" style="color: rgba(0, 0, 0, 0.54)">{{
          $t("roles")
        }}</v-tab>
        <v-tab :to="{ name: 'Departments' }">{{ $t("departments") }}</v-tab>
        <v-tab class="active">{{ $t("permissions") }}</v-tab>
      </v-tabs>
      <div class="d-flex mb-4">
        <h2>{{ $t("permissions") }}</h2>
        <v-spacer></v-spacer>
        <!-- <v-btn
          color="primary"
          dark
          class="mr-3"
          :to="{ name: 'Roles', params: { department: department } }"
          small
        >
          {{ $t("roles") }}
        </v-btn> -->
      </div>
      <v-card elevation="0" class="px-5" id="permissionlist">
        <v-card-text class="pt-15 pb-7">
          <div class="d-flex mt-5">
            <v-select
              :items="departmentList"
              item-text="name"
              item-value="departmentNumber"
              dense
              outlined
              class="shrink mr-2 wdt"
              v-model="department"
              :placeholder="$t('user.allDepartment')"
              @change="getRoles"
            ></v-select>
            <v-select
              :items="rolesList"
              item-text="name"
              item-value="roleNumber"
              dense
              outlined
              class="shrink mr-2 wdt"
              v-model="role_number"
              :placeholder="$t('user.allRole')"
              :loading="roleLoading"
            ></v-select>
            <v-text-field
              prepend-inner-icon="mdi-magnify"
              outlined
              height="5px"
              placeholder="Search By Module Name"
              dense
              :value="search"
              class="shrink"
              @input="searchPermission"
            ></v-text-field>
            <v-btn
              color="gray"
              height="40"
              width="40"
              max-width="40"
              outlined
              class="ml-8"
              @click="goToRole"
            >
              <v-icon>mdi-filter-outline</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <div class="py-1 title">
              {{ from }} - {{ to }} of {{ totalPermissions }}
            </div>
            <v-btn
              class="mx-2"
              fab
              small
              outlined
              color="primary"
              :disabled="tableOptions && tableOptions.page <= 1"
              @click="pageChange(false)"
            >
              <v-icon dark> mdi-chevron-left </v-icon>
            </v-btn>
            <v-btn
              class="mx-2"
              fab
              small
              outlined
              color="primary"
              :disabled="tableOptions && tableOptions.page >= totalPages"
              @click="pageChange(true)"
            >
              <v-icon dark> mdi-chevron-right </v-icon>
            </v-btn>
            <!-- <v-spacer></v-spacer>
                        <v-btn
                            class="mx-2"
                            fab
                            small
                            outlined
                            color="primary"
                        >
                            <v-icon dark>
                                mdi-chevron-left
                            </v-icon>
                        </v-btn>
                        <v-btn
                            class="mx-2"
                            fab
                            small
                            outlined
                            color="primary"
                        >
                            <v-icon dark>
                                mdi-chevron-right
                            </v-icon>
                        </v-btn> -->
          </div>
          <v-form>
            <v-data-table
              :headers="headers"
              :items="permissions"
              :items-per-page="10"
              item-key="moduleId"
              hide-default-footer
              :loading="loading"
              v-model="selected"
              show-select
              :loading-text="this.$t('loadingData')"
              :options.sync="tableOptions"
              :server-items-length="totalPermissions"
            >
              <template v-slot:no-data v-if="permissions.length < 1">
                NO Module AVAILABLE
              </template>
              <template v-if="permissions.length > 0" v-slot:body="{ items }">
                <tbody>
                  <tr v-for="(item, i) in items" :key="item.moduleId">
                    <td>
                      <v-checkbox
                        multiple
                        v-model="selected"
                        :value="item"
                        style="margin: 0px; padding: 0px"
                        hide-details
                        v-on:click.stop=""
                      />
                    </td>
                    <!-- <td>{{ i + 1 }}.</td> -->
                    <td class="">
                      {{ item.module }}
                    </td>
                    <td>
                      <!-- <input type="checkbox" v-model="permissions[i].canRead"> -->
                      <v-checkbox
                        v-model="permissions[i].canRead"
                        :false-value="0"
                        :true-value="1"
                      ></v-checkbox>
                    </td>
                    <td>
                      <!-- <input type="checkbox" v-model="permissions[i].canUpdate"> -->
                      <v-checkbox
                        v-model="permissions[i].canUpdate"
                        :false-value="0"
                        :true-value="1"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
              <template v-slot:footer></template>
            </v-data-table>
          </v-form>
          <p class="mt-10">&nbsp;</p>
          <v-card-actions v-if="this.permissions.length">
            <v-spacer></v-spacer>
            <v-btn
              width="146"
              :to="{ name: 'Roles', params: { department: department } }"
              class=""
              >Cancel</v-btn
            >
            <v-btn width="146" @click="updatePermissions" class="primary"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import PermissionsMixin from "@/mixins/PermissionsMixin";
import loadingMixin from "@/mixins/LoadingMixin";
import PermissionsService from "@/_services/PermissionsService";

export default {
  mounted() {
    if (this.$route.params.department)
      this.department = this.$route.params.department;
    if (this.$route.params.role_number)
      this.role_number = this.$route.params.role_number;

    const fetchData = async () => {
      // this.startLoading();
      this.departmentList = await this.getDepartments();
      if (this.department)
        this.rolesList = await this.getRolesList(this.department);
      if (this.department && this.role_number) {
        // this.permissions = await this.getRolePermissions(
        //   this.department,
        //   this.role_number
        // );
        this.getPermissions(this.department, this.role_number);
      }
      // this.stopLoading();
    };
    fetchData();
  },
  updated() {
    let element = document.getElementById("permissionlist").childNodes[0];
    this.changeTableSortIcon(element);
  },
  watch: {
    tableOptions: {
      handler() {
        this.getPermissions(this.department, this.role_number);
      },
      deep: true,
    },
    "$route.params": {
      handler(next, old) {
        if (
          old?.department !== next?.department ||
          next?.role_number !== next?.role_number
        ) {
          this.getPermissions(this.department, this.role_number);
        }
      },
      deep: true,
      immediate: true,
    },
  },

  data() {
    return {
      roleLoading: false,
      department: null,
      role_number: null,
      permissions: [],
      totalPermissions: 0,
      to: 0,
      from: 0,
      pageCount: 0,
      totalPages: 0,
      orgPermissions: [],
      departmentList: [],
      rolesList: [],
      selected: [],
      search: "",
      loading: false,
      headers: [
        // {
        //   text: this.$t("Sr."),
        //   class: "black--text",
        //   sortable: false,
        //   width: "2%",
        // },
        {
          text: this.$t("pages"),
          align: "start",
          sortable: true,
          value: "module",
          class: "black--text",
        },
        {
          text: this.$t("view"),
          value: "canRead",
          class: "black--text",
          width: "25%",
        },
        {
          text: this.$t("edit"),
          value: "canUpdate",
          class: "black--text",
          width: "25%",
        },
      ],
      breadcrumbs: [
        {
          text: this.$t("dashboard"),
          disabled: false,
          to: "/",
          exact: true,
        },
        {
          text: this.$t("users"),
          disabled: false,
          to: { name: "Users" },
          exact: true,
        },
        // {
        //   text: this.$t("roles"),
        //   disabled: false,
        //   to: { name: "Roles" },
        //   exact: true,
        // },
        {
          text: this.$t("permissions"),
          disabled: true,
          to: { name: "Roles" },
        },
      ],
    };
  },
  methods: {
    async getRoles() {
      // this.startLoading();
      this.rolesList = [];
      this.roleLoading = true;
      this.rolesList = await this.getRolesList(this.department);
      this.roleLoading = false;
      // this.stopLoading();
    },
    goToRole() {
      this.$router.push({
        name: "Permissions",
        params: { department: this.department, role_number: this.role_number },
      });
    },
    changeTableSortIcon(element) {
      let allTh =
        element.childNodes[1].childNodes[0].childNodes[0].childNodes[0]
          .childNodes[1].childNodes[0].childNodes;
      let index = 0;
      for (let el of allTh) {
        if (index > 0 && el.childNodes[1])
          el.childNodes[1].className =
            "v-icon notranslate v-data-table-header__icon mdi mdi-unfold-more-horizontal theme--light";
        index++;
      }
    },
    pageChange(t) {
      if (t) this.tableOptions.page = this.tableOptions.page + 1;
      else this.tableOptions.page = this.tableOptions.page - 1;

      this.getPermissions(this.department, this.role_number);
    },
    async getPermissions(department, role_number) {
      this.loading = true;
      if (department && role_number) {
        PermissionsService.getRolePermissions(
          this.tableOptions,
          department,
          role_number,
          this.search
        )
          .then((res) => {
            this.permissions = res.data.data.permissions.rows;
            this.totalPermissions = res.data.data.permissions.total_rows;
            this.pageCount = Math.ceil(
              this.totalPermissions / this.tableOptions.itemsPerPage
            );
            this.totalPages = Math.ceil(
              this.totalPermissions / this.tableOptions.itemsPerPage
            );
            this.from =
              (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
            this.to =
              this.tableOptions.page * this.tableOptions.itemsPerPage -
              (this.tableOptions.itemsPerPage -
                res.data.data.permissions.num_rows);
            this.loading = false;
          })
          .catch((err) => {
            console.log(err, "err");
            this.loading = false;
          });
      }
    },
    searchPermission(text) {
      if (!this.department || !this.role_number) return;
      this.search = text;
      this.getPermissions(this.department, this.role_number);
    },
    async routeChanged() {
      if (!this.department || !this.role_number) return;
      this.startLoading();
      this.orgPermissions = await this.getPermissions(
        this.department,
        this.role_number
      );
      this.permissions = [...this.orgPermissions];
      this.stopLoading();
    },

    async updatePermissions() {
      if (this.permissions == this.orgPermissions) return;
      const data = {
        departmentId: this.department,
        roleId: this.role_number,
        permissions: this.permissions,
      };
      this.startLoading();
      const res = await PermissionsService.updateRolePermissions(data);
      if (res.success) {
        this.$notify({
          title: this.$t("user.permissionsUpdated"),
          text: res.message,
          type: "success",
        });
      } else {
        this.$notify({
          title: this.$t("user.permissionsnotUpdated"),
          text: "server error",
          type: "error",
        });
      }
      this.stopLoading();
    },
  },
  mixins: [PermissionsMixin, loadingMixin],
};
</script>
<style lang="scss" scoped>
::v-deep .wdt {
  width: 250px;
}

tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.035);
}

.active {
  color: $primary_color !important;
  border-bottom: 2px solid $primary_color;
}
::v-deep .v-tabs-slider-wrapper .v-tabs-slider {
  background-color: transparent !important;
}

::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}
.v-tab {
  text-transform: none !important;
}
</style>